import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import "./ContactInfoFirst.css";

class ContactInfoFirst extends Component {
  render() {
    const { data, language } = this.props;
    return (
      <div className="ContactInfoFirst">
        <div className="ContactInfoFirst-text">{data.text[language]}</div>
        <div className="ContactPhoto--Mobile">
          <div
            className="Contact-imageMobile"
            style={{ backgroundImage: `url(${data.photo2})` }}
          />
          <div
            className="Contact-imageMobile2"
            style={{ backgroundImage: `url(${data.photo3})` }}
          />
        </div>
        <div
          className="ContactInfoFirst-image"
          style={{ backgroundImage: `url(${data.photo})` }}
        />
        <div className="ContactInfoFirst-content">
          <div className="ContactBorder" />
          <h4 className="ContactInfoTitle">{data.title[language]}</h4>
          <span className="ContactInfoSubTitle">{data.subtitle}</span>
          <span className="ContactInfoSubTitle--Bold">
            {data.subtitle2[language]}
          </span>
          <p className="ContactInfoDesc">{data.description[language]}</p>
          <p className="ContactInfoDesc2">{data.description2[language]}</p>
          <p className="ContactInfoDesc2">{data.description3[language]}</p>
          <div className="InfoBorder" />
          <p className="ContactInfoDesc3">info@igortodorovic.com</p>
          <p className="ContactInfoDesc4">+381112623371</p>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    language: state.language
  };
}

export default withRouter(connect(mapStateToProps)(ContactInfoFirst));



// WEBPACK FOOTER //
// ./src/components/ContactInfo/ContactInfoFirst/index.js